<template>

  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='grid-wrap'>
      <dx-data-grid ref='refInventoryGrid'
        :data-source='productionResultInfo'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="seqId"
        @toolbar-preparing='onToolbarPreparing'
        @cell-prepared='onCellPreparedOutput'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="exportTitle"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="false"/>
        <DxColumn
          :allowEditing='false'
          caption="고객사"
          data-field="납품처코드"
        >
          <DxLookup
            :data-source="$store.getters.getFirstVendor"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :caption="$store.getters.getGroupName"
          data-field="차종"
        >
         <DxLookup
            :data-source="차종리스트"
            display-expr="차종"
            value-expr="차종"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품명"
          data-field="품명"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
          width="60"
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          v-if="isSemiPress"
          caption="규격"
          alignment="center"
        >
          <DxColumn
            :allowEditing='true'
            caption="두께"
            data-field="자사두께"
            :visible='true'
            format='#,##0.0'
            dataType="number"
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="가로"
            data-field="자사가로"
            :visible='true'
            format='#,##0'
            dataType="number"
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="세로"
            data-field="자사세로"
            :visible='true'
            format='#,##0'
            dataType="number"
            width="60"
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          v-if="isSemiPress"
          caption="월사용량"
          alignment="center"
        >
          <DxColumn
            :allowEditing='true'
            caption="RM중량"
            data-field="원단위"
            :visible='true'
            format='#,##0.0000'
            dataType="number"
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="COIL사용량"
            data-field="COIL소요량"
            :calculate-cell-value="calcAmountWeight"
            :visible='true'
            format='#,##0'
            dataType="number"
            width="80"
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="생산수량"
          data-field="양품"
          dataType='number'
          :visible='true'
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="재생산수량"
          data-field="재생산수량"
          dataType='number'
          :visible='true'
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          caption="생산금액"
           alignment="center"
        >
          <DxColumn
            :allowEditing='false'
            caption="생산단가"
            data-field="판매가"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="생산금액"
            data-field="생산금액"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          caption="도급금액"
           alignment="center"
        >
          <DxColumn
            :allowEditing='false'
            caption="도급단가"
            data-field="외주가공비"
            format='#,##0.00'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="도급비용"
            data-field="도급금액"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="생산기준일"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="양품"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="재생산수량"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="생산금액"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="도급금액"
            display-format="{0}"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport } from 'devextreme-vue/data-grid'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      productionResultInfo: null,
      exportTitle: null,
      yearArray: [],
      thisYear: null,
      monthArray: [],
      thisMonth: null,
      차종리스트: [],
      itemTypeLookup: this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    }
  },
  props: {
    pType: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    option: {
      type: String,
      default: null
    }
  },
  computed: {
    isProduct () {
      return this.pType === ConstDef.완제품
    },
    isSemiPress () {
      return this.pType === ConstDef.다공정품
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.init()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    init () {
      this.yearArray = []
      this.thisYear = AppLib.getThisYear()
      for (let i = this.thisYear; i >= 2021; i--) {
        this.yearArray.push({ 'year': i })
      }
      this.thisMonth = AppLib.getThisMonth()
      this.monthArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          this.monthArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          this.monthArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      this.refreshProductResult()
    },
    calcAmountWeight (row) {
      if (row.원단위 === null) return null
      return row.양품 * row.원단위
    },
    onCellPreparedOutput (e) {

    },
    onToolbarPreparing (e) {
      if (this.option === 'MONTH') {
        e.toolbarOptions.items.unshift(
          {
            location: 'before',
            template: function () {
              return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
            }
          },
          {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
              width: 80,
              items: this.yearArray,
              valueExpr: 'year',
              displayExpr: 'year',
              value: this.thisYear,
              onValueChanged: (args) => {
                this.thisYear = args.value
                this.refreshProductResult()
              }
            }
          },
          {
            location: 'before',
            template: function () {
              return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
            }
          },
          {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
              width: 80,
              items: this.monthArray,
              valueExpr: 'value',
              displayExpr: 'name',
              value: this.thisMonth,
              onValueChanged: (args) => {
                this.thisMonth = args.value
                this.refreshProductResult()
              }
            }
          }
        )
      } else {
        e.toolbarOptions.items.unshift(
          {
            location: 'before',
            template: function () {
              return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
            }
          },
          {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
              width: 80,
              items: this.yearArray,
              valueExpr: 'year',
              displayExpr: 'year',
              value: this.thisYear,
              onValueChanged: (args) => {
                this.thisYear = args.value
                this.refreshInventoryList('production')
              }
            }
          }
        )
      }
    },
    refreshProductResult () {
      this.isLoading = true
      this.exportTitle = `${this.thisYear}-${this.thisMonth}-${this.title}`
      let param = null
      if (this.option === 'MONTH') {
        param = {
          startDate: `${this.thisYear}-${this.thisMonth}-01`,
          endDate: `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)} 23:59:59`,
          품목유형: this.pType,
          isGroup: true
        }
      } else {
        param = {
          startDate: `${this.thisYear}-01-01`,
          endDate: `${this.thisYear}-12-31 23:59:59`,
          품목유형: this.pType,
          isGroup: true
        }
      }

      this.$_sp.runNoEncodeFindProc('spFindAllProductResultByType', param)
        .then((data) => {
          this.isLoading = false
          this.productionResultInfo = this.$_sp.MakeModel(data)
          this.차종리스트 = []
          const gByCarType = this.$_.groupBy(this.productionResultInfo, function (carList) { return carList.차종 })
          let array = Object.keys(gByCarType)
          for (var i in array) {
            this.차종리스트.push({ 차종: array[i] })
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
